// extracted by mini-css-extract-plugin
module.exports = {"container":"PvTemplates_container__2ipFU","wrapper":"PvTemplates_wrapper__10nLE","list":"PvTemplates_list__CFiPD"};